<template>
  <div
    class="plan-benefits flex flex-wrap gap-1 justify-between text-xs md:text-sm whitespace-nowrap max-w-[410px] md:max-w-[460px] mx-auto w-full pt-7 pb-1 px-3 -mt-5 mb-1 rounded-b-md"
    :class="plan ==='subscription' ? 'bg-[#ddeecb]' : 'bg-gray-100'"
  >
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        {{ $t('/bundler.savings_off_first_order', { firstSavings: formatCents(selectedPricing.firstSavings) }) }}
      </div>
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        {{ $t('/bundler.savings_off_future_orders', { savings: formatCents(selectedPricing.savings) }) }}
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        <span v-html="$t('/bundler.5_day_email_reminder_cancel_anytime')" />
      </div>
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        {{ $t('/bundler.free_new_flavor_with_every_box') }}
      </div>
    </div>
   </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { formatCents } from '@/utils'
import { useBundleStore } from '@/stores'

const store = useBundleStore()
const { selectedPricing, plan } = storeToRefs(store)

const checkColor = computed<string>(() => plan.value === 'subscription' ? 'text-green-400' : 'text-gray-300')
</script>

<style>
@reference 'tailwindcss';
.plan-benefits {
  @media (max-width: 389px) {
    @apply flex-col;
  }
  @media (max-width: 395px) {
    @apply px-2!;
  }
}
</style>
